import {TOKENS} from '../../tokens'

export const nudge = {
  dark: {
    /**
     * Color for nudge indicators (dot badge, "New" label, feature-highlight
     * icon). Matches the dark-theme primary button background.
     */
    accent: TOKENS.dark.positive_700,
    /** Subtle background behind a nudge icon (e.g. BetaBadge container). */
    accentSubtle: TOKENS.dark.positive_50,
  },
  light: {
    /**
     * Color for nudge indicators (dot badge, "New" label, feature-highlight
     * icon). Matches the light-theme primary button background.
     */
    accent: TOKENS.light.primary_500,
    /** Subtle background behind a nudge icon (e.g. BetaBadge container). */
    accentSubtle: TOKENS.light.primary_50,
  },
} as const
